<template>
  <div
    v-show="$store.state.displayPopMenu"
    id="popMenu"
  >
    <menu-button
      v-show="showMainButton"
      id="main"
      class="menu main-button"
      bottom="2em"
      left="2em"
      :button-size="$mq | mq({ mobile: '60px', tablet: '80px' })"
      :button-color="baseColor"
      :is-fab="false"
      :displayed="true"
      icon="mdi-plus"
      :icon-color="$mq | mq({ mobile: iconColor, tablet: iconColor, desktop: iconColor })"
      @click.native="$store.commit('toggleSubMenus')"
    />
    <menu-button
      v-for="(btn,i) in btns"
      :id="btn.id"
      :key="i"
      :ref="btn.id"
      class="menu sub"
      :class="btn.class"
      :bottom="calcY(i, dist, v, xMain)+ 'em'"
      :left="calcX(i, dist, v, xMain)+ 'em'"
      :button-size="$mq | mq({ mobile: '44px', tablet: '50px', desktop: '80px' })"
      :button-color="$mq | mq({ mobile: baseColor, desktop: baseColor })"
      :is-fab="true"
      :displayed="$store.state.displaySubMenus"
      :icon="btn.icon"
      :icon-size="$mq | mq({desktop: btn.iconSizeDesktop })"
      :icon-color="$mq | mq({ mobile: iconColor, tablet: iconColor, desktop: iconColor })"
      @click.native="$store.commit(btn.action)"
    />
  </div>
</template>

<script>

import MenuButton from './MenuButton.vue';
import { EventBus } from '../event-bus';

const displayed = false;
const showMainButton = true;
export default {
  name: 'PopMenu',
  components: {
    MenuButton,
  },
  props: {
    dist: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      btns: [
        {
          id: 'searchButton',
          class: 'search-button',
          icon: 'mdi-magnify',
          action: 'showSearchMenu',
        },
        {
          id: 'layerButton',
          class: 'layer-button',
          icon: 'mdi-layers',
          action: 'showLayerMenu',
          iconSizeDesktop: 'mdi-36px',
        },
        {
          id: 'settingsButton',
          class: 'settings-button',
          icon: 'mdi-cogs',
          action: 'showSettingsMenu',
          iconSizeDesktop: 'mdi-24px',
        },
      ],
      displayed,
      showMainButton,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      xMain: 2,
      yMain: 2,
      v: Math.PI / 2 / (3 - 1),
    };
  },
  beforeCreate() {
    if (this.$mq === 'tablet') {
      this.btns = this.btns.filter((obj) => obj.id !== 'searchButton');
    }
  },
  created() {
    const me = this;
    if (window.innerWidth >= 1250) {
      me.displayed = true;
    }
    /* BUG does not work as expected */
    if (this.$mq === 'tablet') {
      this.btns = this.btns.filter((obj) => obj.id !== 'searchButton');
    }
  },
  mounted() {
  },
  methods: {
    emit(event) {
      EventBus.$emit(event);
    },
    calcX(i, d, v, xMain) {
      return Math.sin(i * v) * d + xMain;
    },
    calcY(i, d, v, xMain) {
      return Math.cos(i * v) * d + xMain;
    },
  },
};

</script>

<style>

  #pop-menu {
    z-index: 1;
    position: fixed;
    bottom: 0;
    left: 0;
  }
  /* TODO resolve media queries into vue-mq */
  /* |-> Problem: ids are generated by v-for */
  @media (min-width: 1250px) {
    .main-button, #searchButton {
      display: none;
    }

    #settingsButton {
      width: 44px !important;
      height: 44px !important;
      /* background-color: rgb(202, 202, 202) !important; */
    }
  }

    /* @media (min-width: 450px) and (max-width: 1249px) {
    #layerButton{
      left: 3em !important;
      bottom: 3em !important;
    }
    #settingsButton {
      left: unset !important;
      right: 1em !important;
      top: 1em !important;
    }
  }*/

  @media (min-width: 1250px) {
    #layerButton{
      left: 2em !important;
      bottom: 2em !important;
    }
    #settingsButton {
      left: auto !important;
      right: 1em !important;
      top: 1em !important;
      background-color: rgba(202, 202, 202,.9) !important;
    }
  }

</style>
